import React from 'react';

import { EncodingPlaceholder, FailedPlaceholder, UnverifiedPlaceholder } from '@bingads-webui-campaign-react/video-status-placeholder-pure-component';

import { usePlaceholderStyle } from './style';

export const EncodingPlaceholderWithStyle = (props) => {
  const classes = usePlaceholderStyle();
  return <EncodingPlaceholder {...props} classes={classes} />;
};

export const FailedPlaceholderWithStyle = (props) => {
  const classes = usePlaceholderStyle();
  return <FailedPlaceholder {...props} classes={classes} />;
};

export const UnverifiedPlaceholderWithStyle = (props) => {
  const classes = usePlaceholderStyle();
  return <UnverifiedPlaceholder {...props} classes={classes} />;
};
